import PageHeader from '@common/src/pageheader/pageheader'

const Empty = () => {
  return <PageHeader currentpage="Empty" activepage="Pages" mainpage="Empty" />
}

export default Empty
